import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BasketArticleDto} from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'app-universal-counter',
    templateUrl: './universal-counter.component.html',
    styleUrls: ['./universal-counter.component.less']
})
export class UniversalCounterComponent {
    @Input() showAdd = true;
    @Input() article: BasketArticleDto;
    @Input() mode: 'vertical' | 'horizontal' = 'vertical';
    @Input() customClass: string;
    @Input() isAlowNegative = false;

    @Output()
    addToBasket: EventEmitter<BasketArticleDto> = new EventEmitter();

    @Output()
    onChangeCounter?: EventEmitter<any> = new EventEmitter();

    @Output()
    onChangeCounterWithValue?: EventEmitter<number> = new EventEmitter<number>();

    increment() {
        if (this.article) {
            this.article.quantity++;

            if (this.onChangeCounterWithValue) {
                this.onChangeCounterWithValue.emit(this.article.quantity);
                return;
            }

            if (this.onChangeCounter)  {
                this.onChangeCounter.emit();
            }
        }
    }

    decrement() {
        if (this.article) {
            if (this.isAlowNegative || this.article.quantity > 1) {
                this.article.quantity--;
            }

            if (this.onChangeCounterWithValue) {
                this.onChangeCounterWithValue.emit(this.article.quantity);
                return;
            }

            if (this.onChangeCounter)  {
                this.onChangeCounter.emit();
            }
        }
    }

    add() {
        this.addToBasket.emit(this.article);
    }

    openProductSelector() {
        if (!this.showAdd) {
            abp.event.trigger('app.toggle.productSelectorModal', this.article);
        } else {
            abp.event.trigger('app.show.productSelectorModal', this.article);
        }
    }
}
